var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClashbotLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 1001.5748031496063 1001.514435695538",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l1001.5748 0l0 1001.51447l-1001.5748 0l0 -1001.51447z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l1001.5748 0l0 1001.51447l-1001.5748 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "p.1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(33.220391857102626 0.0 0.0 33.220391857102626 0.0 0.0)",
    spreadMethod: "pad",
    x1: -8.416766091118648,
    y1: 15.084178517511628,
    x2: 15.082948957762044,
    y2: 38.56518845662756
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d63031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#d63031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5500001,
    stopColor: "#ff7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#ff7675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71000004,
    stopColor: "#fab1a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fab1a0"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p.1)",
    d: "m353.36975 785.52496l-199.59627 -231.07355l59.30832 -216.25458l-45.051132 -268.12598l261.75513 269.20474l-49.614655 37.05249l239.51508 0l-47.901733 -37.72705l261.7552 -271.2257l-45.62213 273.11285l59.879272 212.48032l-201.307 231.74805l161.6726 -371.60632l-72.1391 54.165375l-234.95377 466.8635l-235.52252 -465.51706l-72.425735 -56.52231z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d63031",
    d: "m133.00131 605.56696l166.7139 166.71387l-141.1496 -81.49341z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fab1a0",
    d: "m868.57086 605.56696l-166.71393 166.71387l141.14966 -81.49341z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7675",
    d: "m270.77502 796.03784l103.72937 56.215942l-79.322266 -18.978577z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fab1a0",
    d: "m730.7957 796.03784l-103.72937 56.215942l79.322266 -18.978577z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClashbotLogo);
export default __webpack_public_path__ + "static/media/clashbot_logo.cf4a74c1b0d265d4b0978b0d8732b63a.svg";
export { ForwardRef as ReactComponent };